<div class="w-full h-full rounded-md border-gray-400 border-0 border-dashed" [class.border-2]="isDragOver" (click)="fileInput.click()" [host]="this" dropFile>
    <img class="w-full h-full cursor-pointer rounded-full" [src]="imageUrl" alt="User avatar">
    <input class="hidden" #fileInput (change)="onFileSelected($event)" type="file" />
</div>
